const WHATS_NEW = {
  text: 'See what\'s new in Dyzio',
  link: 'https://help.dyzio.co/en/articles/6987785-product-update-feb-23',
};

module.exports = {
  WHATS_NEW,
};



/** WEBPACK FOOTER **
 ** ./src/utils/whats-new.js
 **/